import React from 'react';

const InputSelect = ({val ,setval  , array , title  } ) => {
  return (
    <div className="mb-4 w-full flex flex-wrap items-center">

        <label htmlFor={title} className="w-full block m-2 mb-2 font-medium text-gray-700">
          {title}:
        </label>
        <select
    id={title}
    value={val}
    onChange={(e) => setval(e.target.value)}
    className="w-100 py-2 px-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"   >
      <option value={""}>select {title}</option>
        {array.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
    </select> 
       
      </div>
  );
};

export default InputSelect;